import { createContext, useContext } from 'react';
export const CardTableContext = createContext({
    colWidths: {},
    expandedRows: [],
    visibleColumns: [],
    hiddenColumns: [],
    isMobile: false,
    isResizing: false,
    setRowExpanded: (key, expanded) => void 0,
});
export const useCardTable = () => useContext(CardTableContext);
//# sourceMappingURL=Context.js.map